import {AI_MATCH_TITLE} from '../../configs/aiMatch';
import {GAME_FIELDS} from '../../configs/fields';

// Больше игроков лобби не вмещает (тот же предел у сервера и у кнопки
// «Начать матч»)
export const LOBBY_MAX_PLAYERS = 6;

/**
 * Заголовок лобби — один для десктопа (шапка) и телефона (над списком
 * игроков, пока нет арта своей фракции)
 *
 * @param {Object} lobby
 * @param {boolean} isAiLobby
 * @returns {string}
 */
export const getLobbyTitle = (lobby, isAiLobby) => {
  if (isAiLobby) return AI_MATCH_TITLE;
  return lobby.isRanked ? 'Рейтинговый матч' : 'Сетевой матч';
};

/**
 * Подзаголовок лобби: сколько игроков (в обычном — из скольких мест) и поле,
 * если его выбрал создатель
 *
 * @param {Object} lobby
 * @param {number} playersCount
 * @returns {string}
 */
export const getLobbySubtitle = (lobby, playersCount) => {
  const fieldName = lobby.selectedFieldId
    ? GAME_FIELDS.find((field) => field.id === lobby.selectedFieldId)?.name
    : null;
  return [
    lobby.isRanked ? `Игроков: ${playersCount}` : `Игроки: ${playersCount} из ${LOBBY_MAX_PLAYERS}`,
    fieldName ? `Поле: ${fieldName}` : null,
  ].filter(Boolean).join(' · ');
};
